export default "__VITE_ASSET__CtmPE28j__"